import { AddRentChargeFormModalContext } from '@/contexts'
import { useContext } from 'react'

export const useAddRentChargeFormModalContext = () => {
  const context = useContext(AddRentChargeFormModalContext)

  if (!context) throw new Error('addRentChargeFormModalContext have to bee wraped by RentChargeFormModalContextProvider')

  return context
}